import { call, put, takeLatest } from "redux-saga/effects";
import { fetchIncentives } from "./incentivesApi";
import { fetchIncentiveSettingsApi, saveIncentiveSettingsApi } from "./incentiveSettingApi";
import {
  getIncentivesStart,
  getIncentivesSuccess,
  getIncentivesFailure,
  getIncentiveSettingsStart,
  getIncentiveSettingsSuccess,
  getIncentiveSettingsFailure,
  saveIncentiveSettingsStart,
  saveIncentiveSettingsSuccess,
  saveIncentiveSettingsFailure,
} from "./incentiveSlice";

function* fetchIncentivesSaga(action) {
  try {
    const { key, ...apiParams } = action.payload;
    const response = yield call(fetchIncentives, apiParams);
    
    // Pass key back to reducer
    yield put(getIncentivesSuccess({
        key, 
        data: response.data,
        totalCount: response.totalCount
    }));
  } catch (error) {
    const { key } = action.payload; // Extract key from action
    console.error("Incentives fetch error:", error);
    
    // Handle 404 as Empty Success
    if (error.message?.includes("404") || error.response?.status === 404) {
         yield put(getIncentivesSuccess({
            key, 
            data: [],
            totalCount: 0
        }));
        return;
    }

    yield put(getIncentivesFailure({
        key,
        error: error.message || "Failed to fetch incentives"
    }));
  }
}

function* fetchIncentiveSettingsSaga(action) {
    try {
        const key = action.payload;
        const response = yield call(fetchIncentiveSettingsApi, key);
        // Backend returns { sm: 1, data: {...} }, unwrap it
        const unwrapped = response?.data || response;
        // Response might be an array or object. We expect a single setting object for the key.
        // If array, take first.
        const data = Array.isArray(unwrapped) ? unwrapped[0] : unwrapped;
        
        yield put(getIncentiveSettingsSuccess({ key, data: data || {} }));
    } catch (error) {
        console.error("Settings fetch error:", error);
        yield put(getIncentiveSettingsFailure(error.message));
    }
}

function* saveIncentiveSettingsSaga(action) {
    try {
        const payload = action.payload;
        const response = yield call(saveIncentiveSettingsApi, payload);
        const data = Array.isArray(response) ? response[0] : response;
        
        yield put(saveIncentiveSettingsSuccess({ key: payload.key, data }));
        // Optionally show toast success here if notification system exists
        if(action.payload.onSuccess) action.payload.onSuccess();
    } catch (error) {
        console.error("Settings save error:", error);
        yield put(saveIncentiveSettingsFailure(error.message));
        if(action.payload.onError) action.payload.onError(error.message);
    }
}

export function* watchIncentives() {
  yield takeLatest(getIncentivesStart.type, fetchIncentivesSaga);
  yield takeLatest(getIncentiveSettingsStart.type, fetchIncentiveSettingsSaga);
  yield takeLatest(saveIncentiveSettingsStart.type, saveIncentiveSettingsSaga);
}
